import __request__ from "routing/request";
export function list(requestOptions) {
  return __request__("GET", "/system/indices/retention/strategies", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function configSchema(strategy, requestOptions) {
  return __request__("GET", `/system/indices/retention/strategies/${strategy}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
